/* @ngInject */
export function SelectPpeTestStatusController($ngRedux, LicenceService, ProtectiveEquipmentTestService) {
    var ctrl = this;
    var unsubscribe = angular.noop;

    ctrl.$onInit = function() {
        unsubscribe = $ngRedux.connect(mapStateToThis, {})(this);
        ctrl.options = [];

        ProtectiveEquipmentTestService.getTestStatuses().then(function(items) {
            ctrl.options = items;
        });
    };

    ctrl.$onDestroy = function() {
        unsubscribe();
    };

    ctrl.onSelect = function() {
        if (ctrl.selectedOption) {
            $ngRedux.dispatch({
                type: 'PPE_TEST_STATUS_SELECTED',
                id: ctrl.identifier,
                status: ctrl.selectedOption
            });
        }
    };

    function mapStateToThis(state) {
        return {
            selectedOption: state.protectiveEquipment[ctrl.identifier].filter.status,
        };
    }
}
